<template>
  <div v-if="user !== null">
    <slot :toggle_follow="toggle_follow" :is_following="is_following"></slot>
  </div>
</template>
<script>
  export default {
    props: {
      initial_is_following: {},
      user: {},
      other_user_id : {},
    },
    data: v => ({
      is_following: v.initial_is_following,
    }),
    methods: {
      toggle_follow() {
        let id = this.other_user_id;
        this.is_following ? this.unfollow(id) : this.follow(id)
      },
      follow(id){
        axios.post(`/api/v1/follow/${id}`,{}, {
          params: {api_token: this.user.api_token},
        }).then(resp => {
          this.is_following = true
        })
      },
      unfollow(id){
        axios.delete(`/api/v1/follow/${id}`, {
          params: {api_token: this.user.api_token},
        }).then(resp => {
          this.is_following = false
        })
      }
    }
  }
</script>
